import React from 'react';
import { CoreAsyncButton, CoreTable } from '@amzn/dots-core-ui';
import Column from '@amzn/meridian/column';
import Heading from '@amzn/meridian/heading';
import Row from '@amzn/meridian/row';
import { DevicePool, useClient, Device, useInfiniteGetAll } from '$/api';
import { DeviceColumnDefinitions } from '$/features/Devices';

type PoolDevicesTableProps = {
  pool: DevicePool['name'];
};

export const PoolDevicesTable = ({
  pool,
}: PoolDevicesTableProps): JSX.Element => {
  const { devices } = useClient();
  const devicePoolName = pool;
  const { data, allData, isLoading, hasNextPage, fetchNextPage } =
    useInfiniteGetAll(devices.resourceKey, devices.getAll, { devicePoolName });
  return (
    <Column spacing="small">
      <Heading level={3}>Devices</Heading>

      <CoreTable
        fixHeaderRows
        columnDefinitions={DeviceColumnDefinitions}
        getItemId={(item: Device) => item.id}
        isLoading={isLoading && !data}
        items={allData}
      />
      <Row alignmentHorizontal="center">
        <CoreAsyncButton
          disabled={!hasNextPage}
          type="tertiary"
          onClick={async (): Promise<void> => {
            await fetchNextPage();
          }}
        >
          Load More
        </CoreAsyncButton>
      </Row>
    </Column>
  );
};
